__turbopack_context__.v({
  "select_wrapper": "styles-module-scss-module__eOt3hq__select_wrapper",
});
